import ProxyButton from '../common/ProxyButton';
import { launchedFromLwaProfile, lwaProfileLaunchedParams } from '../../utils/lwa-profile-utils';
import { launchedFromAthenanetUserProfile, sendEnrollmentAbortedNoticeToParentWindow } from '../../utils/athenanet-user-profile-utils';
import { removeStateHandle } from '../../utils/storage-utils';

export default function ChooseDifferentFactorButton ({
  oktaButton,
  buttonLabel,
  onClick,
}: {
  oktaButton: JQuery;
  buttonLabel: string;
  onClick: () => void;
}) {
  const isLaunchedFromLwaProfile = launchedFromLwaProfile();
  const isLaunchedFromAnetProfile = launchedFromAthenanetUserProfile();
  return (
    <ProxyButton
      textToOverride={buttonLabel}
      oktaButton={oktaButton}
      variant="tertiary"
      size="small"
      fullWidth={false}
      suppressOktaClick={isLaunchedFromLwaProfile || isLaunchedFromAnetProfile}
      onClick={() => {
        if (isLaunchedFromLwaProfile) {
          //Make widget forget the state handle so it doesn't land back on same prefilled factor
          removeStateHandle();
          const { lwaProfileUrl } = lwaProfileLaunchedParams();
          window.location.href = lwaProfileUrl;
        }
        else if (isLaunchedFromAnetProfile) {
          removeStateHandle();
          // send a message to parent window to close the popup
          sendEnrollmentAbortedNoticeToParentWindow();
        }
        else {
          onClick();
        }
      }}
    />
  );
}
